import {
  DownOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  InfoCircleFilled,
  SearchOutlined,
  StarOutlined,
  UnorderedListOutlined,
  UpOutlined,
} from "@ant-design/icons";
import React, { ReactNode, useEffect, useState } from "react";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Tabs from "../../../components/AntdTabs/AntdTabs";
import { CardContainer } from "../../../components/Card/CardContainer";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import { useNavigate } from "react-router-dom";
import Text from "../../../components/Text/Text";
import {
  Avatar,
  Button as AntdButton,
  Col,
  Collapse,
  Divider,
  Form,
  Image,
  Input,
  Row,
  Table,
  Tag,
  Space,
  Tooltip,
  Modal,
  Dropdown,
  Select as AntdSelect,
  Checkbox,
  message,
  ConfigProvider,
  Spin,
  Card,
  Tabs as AntdTabs,
} from "antd";
import image from "../../../resource/image";
import styled from "styled-components";
import { Campaign, CampaignProgram } from "../../../entities/CampaignEntity";
import color from "../../../resource/color";
import {
  excelCrmDetail,
  excelCrmTracking,
  getCampaignById,
  getHistoryProgramPoint,
  getZoneForProgram,
  trackingCampaign,
  trackingCampaignDetail,
} from "../../../datasource/CampaignDatasource";
import {
  campaignProgramConditionLabel,
  campaignProgramTypeLabel,
  campaignStatusColorList,
  campaignStatusNameList,
  campaignStatusTextColorList,
  dealerTypeName,
} from "../../../definitions/campaign";
import Button from "../../../components/Button/Button";
import { StoreEntity } from "../../../entities/StoreEntity";
import Select, { AntSelectCustom } from "../../../components/Select/Select";
import { useEffectOnce } from "react-use";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import TableContainer from "../../../components/Table/TableContainer";
import { ProductEntity } from "../../../entities/PoductEntity";
import icon from "../../../resource/icon";
import { CollapseContainer, ProgramTabsContainer, TabBody, TabHeader } from "./ProgramComponents";
import { tabId } from "../../../store/createCampaign";
import { numberFormatter } from "../../../utility/Formatter";
import { FlexCol, FlexRow, ScrollContainer } from "../../../components/Container/Container";
import GreyModal from "../../../components/Modal/GreyModal";
import dayjs from "dayjs";
import { TablePaginationConfig } from "antd/es/table";
import { mapSortingKey } from "../../../definitions/tableFilter";
import { onInputNumberKeyPress } from "../../../utility/validator";
import { getPartnerDealer, getPartnerSubdealer } from "../../../datasource/PartnerDatasource";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../../store/RoleAtom";
import Permission, { checkPermission } from "../../../components/Permission/Permission";
import PageSpin from "../../../components/Spin/pageSpin";
import { CheckboxGroupContainer } from "../../../components/CheckboxGroup/CheckboxGroup";
import { useNotificationContext } from "../../../context/NotificationProvider";
import { formatFileSize } from "../../../utility/formatFileSize";
import { ModalPreviewFile } from "../../NewCODiscount/CODiscountComponent";
import { ShopPointTab } from "../OverviewPoint/TabDetail/ShopPoint";
import { HistoryPointTab } from "../OverviewPoint/TabDetail/HistoryPoint";
import { CouponTab } from "../OverviewPoint/TabDetail/Coupon";
import { DealerReportTab } from "../OverviewPoint/TabDetail/DealerReport";

const Container = styled.div`
  margin: 16px 0px 10px 0px;
`;

const Desc = ({ label, value, icon }: { label: string; value: ReactNode; icon?: ReactNode }) => {
  return (
    <Row style={{ padding: "8px 0px" }}>
      <Col xl={6} sm={8}>
        <Text level={5} color='Text3'>
          {icon && <>{icon}&nbsp;</>}
          {label}
        </Text>
      </Col>
      <Col xl={18} sm={16}>
        <Text level={5} color='Text1'>
          {value || "-"}
        </Text>
      </Col>
    </Row>
  );
};

const TrackingItem = ({
  title,
  number,
  unit,
  info,
}: {
  title: ReactNode;
  number: number | string;
  unit: string;
  info?: { quantity: number; unitName: string }[];
}) => {
  const formattedInfo = info
    ? info.map((item) => `${numberFormatter(item.quantity, 0)} ${item.unitName}`).join("\n")
    : "";
  return (
    <div
      style={{ padding: 16, background: "#FAFAFA", border: "1px solid #E5EAEE", borderRadius: 4 }}
    >
      <Row justify='space-between'>
        <Text fontWeight={700}>{title}</Text>
        {formattedInfo && (
          <Tooltip
            placement='top'
            title={
              <div>
                <Text color='white' fontFamily='Sarabun' fontSize={14} fontWeight={700}>
                  ปริมาณที่สั่งซื้อทั้งหมด
                </Text>
                <div>
                  {formattedInfo.split("\n").map((line, index) => (
                    <Text
                      color='white'
                      fontFamily='Sarabun'
                      fontSize={14}
                      key={index}
                      style={{ display: "block" }}
                    >
                      {line}
                    </Text>
                  ))}
                </div>
              </div>
            }
            trigger='click'
          >
            <InfoCircleFilled style={{ fontSize: 14, cursor: "pointer", color: color.Text1 }} />
          </Tooltip>
        )}
      </Row>
      <br />
      <Text level={2} fontWeight={700} fontSize={28}>
        {number}
      </Text>
      &nbsp;&nbsp;<Text fontWeight={700}>{unit}</Text>
    </div>
  );
};

export const CampaignDetail: React.FC = () => {
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;

  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[3];
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [campaignData, setCampaignData] = useState<Campaign>();
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [zone, setZone] = useState<{ label: string; value: string; key: string }[]>([]);

  const roleData = useRecoilValue(roleAtom);
  const hasPermission = checkPermission(["campaignPoint", "edit"], roleData);
  const [openPdf, setOpenPdf] = useState(false);
  const [previewFile, setPreviewFile] = useState<string | undefined>(undefined);

  const fetchCampaign = async () => {
    await getCampaignById(id)
      .then((res) => {
        setCampaignData(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchHistory = async () => {
    await getHistoryProgramPoint(id)
      .then((res) => {
        setHistoryData(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getZoneByCompany = async () => {
    const res = await zoneDatasource.getAllZoneByCompany(company);
    const data = res?.map((item: any) => {
      return {
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneId,
      };
    });
    setZone(data);
  };

  useEffectOnce(() => {
    if (zone.length <= 0) {
      getZoneByCompany();
    }
  });
  useEffect(() => {
    setLoading(true);
    fetchCampaign();
    fetchHistory();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={"รายละเอียดแคมเปญพอยท์"}
        showBack
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการแคมเปญพอยท์", path: "/crm/campaignPoint" },
              {
                text: "รายละเอียดแคมเปญพอยท์",
                path: window.location.pathname,
              },
            ]}
          />
        }
        extra={
          hasPermission ? (
            <Button
              title='แก้ไข'
              icon={<EditOutlined />}
              onClick={() => navigate(`/crm/createCampaignPoint/${id}`)}
              loading={loading}
              disabled={campaignData && dayjs(campaignData?.endDate).isBefore(dayjs())}
              typeButton={
                campaignData && dayjs(campaignData?.endDate).isBefore(dayjs())
                  ? "disabled"
                  : "primary"
              }
            />
          ) : undefined
        }
      />
    );
  };

  const TabDetail = () => {
    const [showAllDeadlines, setShowAllDeadlines] = useState(false);
    const campaignDeadlines = campaignData?.campaignDeadlines || [];
    const displayedDeadlines = showAllDeadlines ? campaignDeadlines : campaignDeadlines.slice(0, 5);

    const details = [
      {
        label: "สถานะ",
        value: (
          <Tag
            color={campaignStatusColorList[campaignData?.status || ""]}
            style={{ fontWeight: 700 }}
          >
            <Text
              color={campaignStatusTextColorList[campaignData?.status || ""]}
              level={6}
              fontWeight={700}
            >
              {campaignStatusNameList[campaignData?.status || ""]}
            </Text>
          </Tag>
        ),
      },
      {
        label: "รหัสแคมเปญ",
        value: campaignData?.campaignCode,
      },
      {
        label: "ชื่อแคมเปญ",
        value: campaignData?.campaignName,
      },
      {
        label: "ระยะเวลาแคมเปญ",
        value: `${dayjs(campaignData?.startDate).locale("th").format("DD MMM BBBB, HH:mm น.")} - ${dayjs(
          campaignData?.endDate,
        )
          .locale("th")
          .format("DD MMM BBBB, HH:mm น.")}`,
      },
      {
        label: "รูปแบบการให้แต้มกับร้านค้า",
        value:
          campaignData?.campaignProgramType === "ONLY_DEALER"
            ? "ให้ Dealer เท่านั้น"
            : "ให้ Sub-Dealer เท่านั้น",
      },
      ...(campaignData?.campaignProgramType === "ONLY_SUB_DEALER"
        ? [
            {
              label: "Deadline การส่งและตรวจสอบ",
              value: (
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        headerBg: "#F3F6F9",
                        fontFamily: "IBM Plex Sans Thai",
                        fontSize: 15,
                      },
                    },
                  }}
                >
                  <Table
                    columns={[
                      {
                        title: "ใบขนเดือน",
                        dataIndex: "deadlineMonth",
                        key: "deadlineMonth",
                        render: (text) => (
                          <Tag
                            style={{
                              backgroundColor: "#E6F0FE",
                              border: "none",
                            }}
                          >
                            <Text fontWeight={700}>
                              {dayjs(text).locale("th").format("MMM BBBB")}
                            </Text>
                          </Tag>
                        ),
                      },
                      {
                        title: "วันสุดท้าย Sub-Dealer ส่งใบขน",
                        dataIndex: "subDealerSubmitDate",
                        key: "subDealerSubmitDate",
                        render: (text) => (
                          <Text>{dayjs(text).locale("th").format("DD MMM BBBB")}</Text>
                        ),
                      },
                      {
                        title: "วันสุดท้าย Dealer ตรวจสอบ",
                        dataIndex: "dealerCheckDate",
                        key: "dealerCheckDate",
                        render: (text) => (
                          <Text>{dayjs(text).locale("th").format("DD MMM BBBB")}</Text>
                        ),
                      },
                      {
                        title: "วันสุดท้ายบริษัทอนุมัติ",
                        dataIndex: "companyApproveDate",
                        key: "companyApproveDate",
                        render: (text) => (
                          <Text>{dayjs(text).locale("th").format("DD MMM BBBB")}</Text>
                        ),
                      },
                    ]}
                    dataSource={displayedDeadlines}
                    pagination={false}
                    rowKey='deadlineMonth'
                    size='small'
                  />
                  {campaignDeadlines.length > 5 && (
                    <Row
                      style={{ padding: "10px" }}
                      onClick={() => setShowAllDeadlines((prev) => !prev)}
                    >
                      <Text style={{ cursor: "pointer" }} color='primary'>
                        {showAllDeadlines ? "ดูน้อยลง" : `ดูทั้งหมด`}
                      </Text>
                      {showAllDeadlines ? (
                        <UpOutlined style={{ marginLeft: "8px", color: color.primary }} />
                      ) : (
                        <DownOutlined style={{ marginLeft: "8px", color: color.primary }} />
                      )}
                    </Row>
                  )}
                </ConfigProvider>
              ),
            },
          ]
        : []),
      {
        label: "กติกาและเงื่อนไขแคมเปญ",
        value: (
          <div
            className='view ql-editor'
            style={{
              display: "block",
              wordBreak: "break-word",
              wordWrap: "break-word",
              padding: 0,
              maxHeight: "340px",
              overflow: "auto",
            }}
            dangerouslySetInnerHTML={{ __html: campaignData?.campaignCondition || "" }}
          />
        ),
      },
      {
        label: "ตัวอย่างหน้ารายละเอียดแคมเปญ",
        value: (
          <Button
            title='ดูภาพตัวอย่าง'
            onClick={() => setShowPreview(true)}
            typeButton='primary-light'
            icon={<img src={icon.appPreviewIcon} style={{ width: 16, height: 16 }} />}
            style={{ width: 140, height: 28, padding: 0 }}
            size='small'
          />
        ),
      },
    ];
    const previewSize = 290;
    const [showPreview, setShowPreview] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const { startUploadProcess } = useNotificationContext();
    const [progressValue, setProgressValue] = useState(0);

    const onDownloadExcel = async () => {
      setLoadingExcel(true);
      const params = {
        campaignId: id,
        company,
      };

      try {
        const config = await excelCrmDetail(params);
        if (config) {
          const blob = new Blob([config], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          startUploadProcess(
            "",
            progressValue,
            setProgressValue,
            {
              placement: "bottomRight",
              duration: 2,
              label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
              progressInterval: 900,
            },
            async () => {
              try {
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = `ข้อมูลตั้งค่าแคมเปญ_${campaignData?.campaignCode}_${campaignData?.campaignName}_${dayjs(
                  campaignData?.startDate,
                ).format("DD/MM/YYYY")}_${dayjs(campaignData?.endDate).format("DD/MM/YYYY")}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(a.href);
                formatFileSize(blob.size);
              } catch (error) {
                message.error("Export โปรโมชันไม่สำเร็จ");
              } finally {
                setLoadingExcel(false);
              }
            },
          );
        }
      } catch (error) {
        console.error("Error submitting report:", error);
      } finally {
        setLoadingExcel(false);
      }
    };

    return (
      <>
        <div style={{ padding: "16px 0px" }}>
          <Row justify='space-between'>
            <Col span={20}>
              <Text fontWeight={700}>ข้อมูลแคมเปญ</Text>
            </Col>
            <Col span={4}>
              <Button
                title='Export การตั้งค่าแคมเปญ'
                icon={<img src={icon.downloadFileIcon} style={{ width: 20, height: 18 }} />}
                typeButton='primary-light'
                onClick={onDownloadExcel}
                loading={loadingExcel}
              />
            </Col>
          </Row>
          <Row style={{ padding: "16px 0px" }}>
            <Image
              src={campaignData?.imageFilename || image.emptyProductBrand}
              style={{
                width: "234",
                height: "136px",
                objectFit: "contain",
                borderRadius: 4,
              }}
            />
          </Row>
          <Container>
            {details.map((p, i) => (
              <Desc {...p} key={i} />
            ))}
            <Text fontWeight={700}>ไฟล์เอกสารอ้างอิง</Text>
            <Col span={12}>
              <Card bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
                <Row justify='space-between' style={{ alignItems: "center" }}>
                  <Col>
                    <img
                      src={icon.icon_pdf}
                      alt='PDF Icon'
                      style={{ width: "22px", height: "26px" }}
                    />
                    &nbsp;&nbsp;&nbsp;
                    {campaignData?.documentFilename?.length ? (
                      <Text level={6}>
                        {campaignData?.documentFilename?.length > 50
                          ? `${campaignData?.documentFilename.substring(0, 50)}...pdf`
                          : campaignData?.documentFilename}
                      </Text>
                    ) : (
                      <Text color='Text3' level={6}>
                        ไม่มีไฟล์แนบ
                      </Text>
                    )}
                  </Col>
                  <Col>
                    <Button
                      typeButton={campaignData?.documentFilename ? "primary" : "disabled"}
                      icon={<EyeOutlined style={{ color: color.white }} />}
                      title='ดูรายละเอียด'
                      height={40}
                      onClick={() => {
                        if (campaignData?.documentFilename) {
                          setPreviewFile(campaignData?.documentFilename);
                          setOpenPdf(true);
                        }
                      }}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Container>
          {showPreview && (
            <GreyModal
              open={showPreview}
              footer={null}
              onCancel={() => setShowPreview(false)}
              width={900}
            >
              <FlexRow style={{ width: "100%" }} justify='center'>
                <div>
                  {campaignData?.imageFilename && (
                    <div
                      style={{
                        position: "absolute",
                        margin: `${previewSize * 0.244}px 0px 0px`,
                        width: previewSize,
                        height: previewSize * (675 / 1200),
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundImage: `url(${campaignData?.imageFilename})`,
                        backgroundColor: "#FFFFFF40",
                      }}
                    />
                  )}
                  <div
                    style={{
                      position: "absolute",
                      marginTop: previewSize * 0.244 + previewSize * (675 / 1200) + 64,
                      width: previewSize,
                      padding: "2px 8px",
                      background: "white",
                    }}
                  >
                    <Text level={6} fontWeight={600}>
                      <img src={icon.iconMegaphone} style={{ width: "22px" }} />
                      &nbsp;{campaignData?.campaignName || `ชื่อแคมเปญ`}
                    </Text>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      marginTop: previewSize * 0.244 + previewSize * (675 / 1200) + 93,
                      width: previewSize,
                      padding: "2px 8px",
                      background: "#FAFAFA",
                    }}
                  >
                    <Text fontWeight={600} level={6}>
                      ระยะเวลา :{" "}
                      {campaignData?.startDate &&
                        `${dayjs(campaignData?.startDate).format("DD/MM/YYYY")} - `}
                      {campaignData?.endDate && dayjs(campaignData?.endDate).format("DD/MM/YYYY")}
                    </Text>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      marginTop: previewSize * 0.244 + previewSize * (675 / 1200) + 124,
                      width: previewSize,
                      padding: "2px 8px",
                    }}
                  >
                    <Text
                      color='Text1'
                      fontWeight={600}
                      level={6}
                      style={{ backgroundColor: "white" }}
                    >
                      กติกาและเงื่อนไข
                    </Text>
                    <div
                      className='view ql-editor'
                      style={{
                        display: "block",
                        wordBreak: "break-word",
                        wordWrap: "break-word",
                        overflowY: "auto",
                        overflowX: "hidden",
                        height: 244,
                        width: 260,
                        position: "absolute",
                        objectFit: "contain",
                      }}
                      dangerouslySetInnerHTML={{ __html: campaignData?.campaignCondition || "" }}
                    />
                  </div>
                  <div
                    style={{
                      width: previewSize,
                      height: previewSize * 2.18,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: `${previewSize}px ${previewSize * 2.18}px`,
                      backgroundImage: `url(${image.campaignDetail})`,
                    }}
                  />
                </div>
              </FlexRow>
            </GreyModal>
          )}
          <Divider />
          <>
            {campaignData?.campaignPrograms?.map((program: CampaignProgram, i) => {
              const prog = {
                ...program,
                products: program.campaignProgramProducts,
                stores: program.campaignProgramDealers,
              };
              return (
                <>
                  <CollapseContainer>
                    <Collapse
                      collapsible='icon'
                      expandIconPosition='end'
                      expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
                    >
                      <Collapse.Panel
                        header={<ProgramPanelHeader i={i} program={prog} />}
                        key={prog.campaignProgramId}
                      >
                        <ProgramPanelBody i={i} program={prog} />
                      </Collapse.Panel>
                    </Collapse>
                  </CollapseContainer>
                  <br />
                </>
              );
            })}
          </>
        </div>
        {openPdf && (
          <ModalPreviewFile openPdf={openPdf} setOpenPdf={setOpenPdf} fileRef={previewFile} />
        )}
      </>
    );
  };

  const TabTracking = () => {
    const tabs = {
      pointProgram: "PROGRAM",
      store: "SHOP",
      products: "PRODUCT",
      redeem: "REWARD",
    };
    const [loading, setLoading] = useState(false);
    const [trackingData, setTrackingData] = useState<any>();
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [detailData, setDetailData] = useState<any>();

    const [acttiveTab, setActiveTab] = useState(tabs.pointProgram);
    const [page, setPage] = useState(1);
    const resetPage = () => setPage(1);
    const pageSize = 8;
    const { startUploadProcess } = useNotificationContext();
    const [progressValue, setProgressValue] = useState(0);

    const [minMaxQtyStore, setMMStore] = useState<any[]>([null, null]);
    const [filterStore, setFilterStore] = useState<{
      search: string;
      userType: string;
      zone: string | undefined;
      minQuantity: number | undefined;
      maxQuantity: number | undefined;
    }>({
      search: "",
      userType: "ALL",
      zone: undefined,
      minQuantity: undefined,
      maxQuantity: undefined,
    });

    const [zoneData, setZoneData] = useState();

    const [sortField, setSortField] = useState();
    const [sortOrder, setSortOrder] = useState();

    const [modalParner, setModalParner] = useState<boolean>(false);
    const [dataParner, setDataParner] = useState<any>();

    const [loadingExcel, setLoadingExcel] = useState(false);
    const [showDownloadOrder, setDownloadOrder] = useState(false);

    const handleTableChange = (pagination, filters, sorter) => {
      const { field, order } = sorter;
      setSortField(field);
      setSortOrder(mapSortingKey[order]);
    };

    const pagination = {
      position: ["bottomCenter"],
      pageSize,
      current: page,
      total: detailData?.count,
      onChange: (p) => setPage(p),
    } as TablePaginationConfig;

    const details = [
      {
        label: "รหัสแคมเปญ",
        value: trackingData?.campaignCode,
      },
      {
        label: "ชื่อแคมเปญ",
        value: trackingData?.campaignName,
      },
      {
        label: "ระยะเวลาแคมเปญ",
        icon: <img src={icon.crmCalendar} style={{ width: 16, height: 16 }} />,
        value:
          `${
            trackingData?.startDate ? dayjs(trackingData?.startDate).format("DD/MM/YYYY") : ""
          } - ${trackingData?.endDate ? dayjs(trackingData?.endDate).format("DD/MM/YYYY") : ""}` +
          (trackingData?.daysPassed && trackingData?.daysPassed > 0
            ? ` (ผ่านมาแล้ว ${trackingData?.daysPassed} วัน)`
            : ""),
      },
      {
        label: "เป้าหมายในแคมเปญ",
        icon: <img src={icon.crmGoal} style={{ width: 16, height: 16 }} />,
        value: "เพื่อ Rebate", // ", เพื่อแลกของรางวัล"
      },
      {
        label: "ร้านค้าที่เข้าร่วม",
        icon: <img src={icon.crmStore} style={{ width: 16, height: 16 }} />,
        value: (
          <>
            {`${trackingData?.countShop || 0}/${trackingData?.countShopAll} ร้าน `}
            <Tooltip
              placement='top'
              title={
                <>
                  {trackingData?.countDealer > 0 && (
                    <Text color='white'>
                      Dealer&nbsp;:&nbsp;{trackingData?.countDealer}&nbsp;ร้าน
                    </Text>
                  )}
                  {trackingData?.countDealer > 0 && trackingData?.countSubDealer > 0 && <br />}
                  {trackingData?.countSubDealer > 0 && (
                    <Text color='white'>
                      Sub-Dealer&nbsp;:&nbsp;{trackingData?.countSubDealer}&nbsp;ร้าน
                    </Text>
                  )}
                </>
              }
              trigger='click'
            >
              <InfoCircleFilled style={{ fontSize: 14, cursor: "pointer" }} />
            </Tooltip>
          </>
        ),
      },
    ];

    const tabsDetail = [
      {
        key: tabs.pointProgram,
        title: "พอยท์โปรแกรม",
        icon: icon.crmPointInactive,
        iconActive: icon.crmPointActive,
      },
      {
        key: tabs.store,
        title: "ร้านค้า",
        icon: icon.crmStoreInactive,
        iconActive: icon.crmStoreActive,
      },
      {
        key: tabs.products,
        title: "ยอดสินค้า",
        icon: icon.crmProductInactive,
        iconActive: icon.crmProductActive,
      },
      // { key: tabs.redeem, title: "พอยท์โปรแกรม", icon: icon.crmRedeemInactive, iconActive: icon.crmRedeemActive  },
    ];

    const pointProgram = (
      <div>
        <Row justify='end'>
          <Text>ทั้งหมด&nbsp;{detailData?.count}&nbsp;รายการ</Text>
        </Row>
        <br />
        <Table
          loading={loadingDetail}
          pagination={pagination}
          dataSource={detailData?.data}
          columns={[
            {
              title: "ชื่อพอยท์โปรแกรม",
              dataIndex: "campaignProgramName",
              key: "campaignProgramName",
            },
            {
              title: "รูปแบบการให้แต้ม",
              dataIndex: "campaignProgramType",
              key: "campaignProgramType",
              render: (value: string) => <Text>{campaignProgramTypeLabel[value]}</Text>,
            },
            {
              title: "เงื่อนไขการได้รับแต้ม",
              dataIndex: "campaignProgramCondition",
              key: "campaignProgramCondition",
              render: (value: string, row: any) => (
                <Text>{campaignProgramConditionLabel[value]}</Text>
              ),
            },
            {
              title: "จำนวนร้านค้า",
              dataIndex: "countShop",
              key: "countShop",
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value || 0}</Text>
                    <Text level={6} color='Text3'>
                      ร้าน
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "จำนวนคำสั่งซื้อ",
              dataIndex: "countOrder",
              key: "countOrder",
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value || 0}</Text>
                    <Text level={6} color='Text3'>
                      รายการ
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "ปริมาณที่สั่งซื้อ",
              dataIndex: "sumQuantity",
              key: "sumQuantity",
              render: (value: number, row: any) => {
                const quantityUnitList = Array.isArray(row.quantityUnitList)
                  ? row.quantityUnitList
                  : [];
                const formattedInfo =
                  quantityUnitList.length > 0
                    ? quantityUnitList
                        .map((item) => `${numberFormatter(item.quantity, 0)} ${item.unitName}`)
                        .join("\n")
                    : "";

                return (
                  <FlexCol>
                    <Row justify='space-between'>
                      <Text>{value ? numberFormatter(value, 2) : "0.00"}</Text>
                      {quantityUnitList.length > 0 && (
                        <div style={{ top: 1, paddingLeft: 4 }}>
                          <Tooltip
                            placement='top'
                            title={
                              <div>
                                <Text
                                  color='white'
                                  fontFamily='Sarabun'
                                  fontSize={14}
                                  fontWeight={700}
                                >
                                  ปริมาณที่สั่งซื้อทั้งหมด
                                </Text>
                                <div>
                                  {formattedInfo.split("\n").map((line, index) => (
                                    <Text
                                      color='white'
                                      fontFamily='Sarabun'
                                      fontSize={14}
                                      key={index}
                                      style={{ display: "block" }}
                                    >
                                      {line}
                                    </Text>
                                  ))}
                                </div>
                              </div>
                            }
                            trigger='click'
                          >
                            <InfoCircleFilled
                              style={{ fontSize: 14, cursor: "pointer", color: color.Text1 }}
                            />
                          </Tooltip>
                        </div>
                      )}
                    </Row>
                    <Text level={6} color='Text3'>
                      {company === "ICPL" ? "หน่วย" : "ตัน"}
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "ยอดแต้ม",
              dataIndex: "sumPoint",
              key: "sumPoint",
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value ? numberFormatter(value, 2) : "0.00"}</Text>
                    <Text level={6} color='Text3'>
                      แต้ม
                    </Text>
                  </FlexCol>
                );
              },
            },
          ]}
        />
      </div>
    );

    const store = (
      <>
        <br />
        <Row gutter={12}>
          <Col span={6}>
            <Input
              placeholder='รหัสร้านค้า / ชื่อร้านค้า'
              suffix={<SearchOutlined />}
              size='large'
              onPressEnter={(e) => {
                const search = (e.target as HTMLTextAreaElement).value;
                setFilterStore({ ...filterStore, search });
                resetPage();
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              data={[
                {
                  key: "ALL",
                  value: "ALL",
                  label: "ประเภทคู่ค้าทั้งหมด",
                },
                {
                  key: "DEALER",
                  value: "DEALER",
                  label: dealerTypeName["DEALER"],
                },
                {
                  key: "SUB_DEALER",
                  value: "SUB_DEALER",
                  label: dealerTypeName["SUB_DEALER"],
                },
              ]}
              defaultValue={"ALL"}
              value={filterStore?.userType}
              onChange={(userType) => {
                setFilterStore({ ...filterStore, userType });
                resetPage();
              }}
              style={{ width: "100%" }}
              allowClear={false}
            />
          </Col>
          <Col span={4}>
            <Select
              placeholder='เขตทั้งหมด'
              data={zoneData || []}
              value={filterStore?.zone}
              onChange={(zone) => {
                setFilterStore({ ...filterStore, zone });
                resetPage();
              }}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={6}>
            <Space.Compact>
              <Input
                style={{ width: "46%", height: 40 }}
                placeholder='ปริมาณต่ำสุด'
                size='large'
                onChange={({ target: { value } }) => {
                  if (!value.length) {
                    setFilterStore({
                      ...filterStore,
                      minQuantity: undefined,
                      maxQuantity: minMaxQtyStore[1],
                    });
                    setMMStore([undefined, minMaxQtyStore[1]]);
                    return;
                  }
                  const minQuantity = parseFloat(value);
                  setMMStore([minQuantity, minMaxQtyStore[1]]);
                }}
                onClear={() => {
                  setMMStore([null, minMaxQtyStore[1]]);
                  setFilterStore({
                    ...filterStore,
                    minQuantity: undefined,
                    maxQuantity: minMaxQtyStore[1],
                  });
                  resetPage();
                }}
                onPressEnter={(e) => {
                  const minQuantity = parseFloat((e.target as HTMLTextAreaElement).value);
                  setFilterStore({ ...filterStore, minQuantity, maxQuantity: minMaxQtyStore[1] });
                  resetPage();
                }}
                onKeyDown={onInputNumberKeyPress}
                allowClear
              />
              <Text style={{ width: "8%", textAlign: "center", lineHeight: "40px" }}>-</Text>
              <Input
                style={{ width: "46%", height: 40 }}
                placeholder='ปริมาณสูงสุด'
                size='large'
                onChange={({ target: { value } }) => {
                  if (!value.length) {
                    setFilterStore({
                      ...filterStore,
                      maxQuantity: undefined,
                      minQuantity: minMaxQtyStore[0],
                    });
                    setMMStore([minMaxQtyStore[0], undefined]);
                    return;
                  }
                  const maxQuantity = parseFloat(value);
                  setMMStore([minMaxQtyStore[0], maxQuantity]);
                }}
                onClear={() => {
                  setMMStore([minMaxQtyStore[0], null]);
                  setFilterStore({
                    ...filterStore,
                    maxQuantity: undefined,
                    minQuantity: minMaxQtyStore[0],
                  });
                  resetPage();
                }}
                onPressEnter={(e) => {
                  const maxQuantity = parseFloat((e.target as HTMLTextAreaElement).value);
                  setFilterStore({ ...filterStore, maxQuantity, minQuantity: minMaxQtyStore[0] });
                  resetPage();
                }}
                onKeyDown={onInputNumberKeyPress}
                allowClear
              />
            </Space.Compact>
          </Col>
          <Col span={4}>
            <FlexCol style={{ width: "100%", height: "100%" }} justify='end' align='end'>
              <Text>ทั้งหมด&nbsp;{detailData?.count}&nbsp;ร้านค้า</Text>
            </FlexCol>
          </Col>
        </Row>
        <br />
        <Table
          loading={loadingDetail}
          pagination={pagination}
          dataSource={detailData?.data}
          columns={[
            {
              title: "ชื่อร้านค้า",
              dataIndex: "shopName",
              key: "shopName",
              render: (value: number, row: any) => {
                return (
                  <FlexCol>
                    <Text>{value}</Text>
                    <Text level={6} color='Text3'>
                      {row?.shopNo}&nbsp;•&nbsp;{dealerTypeName[row?.shopType]}&nbsp;
                      <InfoCircleFilled
                        style={{ fontSize: 12, cursor: "pointer" }}
                        onClick={() => {
                          setModalParner(!modalParner);
                          getParner(row.shopId, row.shopType);
                        }}
                      />
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "พอยท์โปรแกรมที่ร่วม",
              dataIndex: "countProgram",
              key: "countProgram",
              render: (value: number, row: any) => {
                return (
                  <FlexCol>
                    <Text>
                      {value || 0}&nbsp;
                      <Tooltip
                        placement='top'
                        title={
                          <>
                            <Text fontWeight={700} color='white'>
                              พอยท์โปรแกรมที่เข้าร่วม
                            </Text>
                            {row?.program?.map((p, i) => {
                              return (
                                <>
                                  <br />
                                  <Text color='white'>
                                    {i + 1}.&nbsp;{p.campaignProgramName}
                                  </Text>
                                </>
                              );
                            })}
                          </>
                        }
                        trigger='click'
                      >
                        <InfoCircleFilled style={{ fontSize: 14, cursor: "pointer" }} />
                      </Tooltip>
                    </Text>
                    <Text level={6} color='Text3'>
                      โปรแกรม
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "เขต",
              dataIndex: "shopZone",
              key: "shopZone",
              render: (value: string) => <Text>{value}</Text>,
            },
            {
              title: "จำนวนคำสั่งซื้อ",
              dataIndex: "countOrderPoint",
              key: "countOrderPoint",
              sorter: true,
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value || 0}</Text>
                    <Text level={6} color='Text3'>
                      รายการ
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "ปริมาณที่สั่งซื้อ",
              dataIndex: "sumQuantity",
              key: "sumQuantity",
              sorter: true,
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value ? numberFormatter(value, 2) : 0}</Text>
                    <Text level={6} color='Text3'>
                      {company === "ICPL" ? "หน่วย" : "ตัน"}
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "แต้มที่ได้รับ",
              dataIndex: "sumPoint",
              key: "sumPoint",
              sorter: true,
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value ? numberFormatter(value, 2) : 0}</Text>
                    <Text level={6} color='Text3'>
                      แต้ม
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "",
              dataIndex: "action",
              key: "action",
              render: (value: number, row: any) => {
                return (
                  <FlexCol>
                    <UnorderedListOutlined
                      style={{ color: color["primary"] }}
                      onClick={() => {
                        navigate("/crm/shop-details/" + row.shopId, {
                          state: { row, campaignId: id },
                        });
                      }}
                    />
                  </FlexCol>
                );
              },
            },
          ]}
          onChange={handleTableChange}
        />
      </>
    );

    const products = (
      <div>
        <Row justify='end'>
          <Text>ทั้งหมด&nbsp;{detailData?.count}&nbsp;รายการ</Text>
        </Row>
        <br />
        <Table
          loading={loadingDetail}
          pagination={pagination}
          dataSource={detailData?.data}
          columns={[
            {
              title: "สินค้า",
              dataIndex: "productName",
              key: "productName",
              render: (value: string, row: any) => {
                return (
                  <FlexRow>
                    <FlexCol>
                      <img
                        src={row?.productImage}
                        style={{ width: 50, height: 50, objectFit: "contain" }}
                      />
                    </FlexCol>
                    <FlexCol>
                      <Text>{value}</Text>
                      <Text level={6} color='Text3'>
                        {row?.commonName}
                      </Text>
                    </FlexCol>
                  </FlexRow>
                );
              },
            },
            {
              title: "ขนาด",
              dataIndex: "saleUom",
              key: "saleUom",
              render: (value: number, row: any) => {
                return (
                  <FlexCol>
                    <Text>{value || "-"}</Text>
                    <Text level={6} color='Text3'>
                      {row?.productCode}
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "ปริมาณที่สั่งซื้อ",
              dataIndex: "sumQuantity",
              key: "sumQuantity",
              sorter: true,
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value ? numberFormatter(value, 2) : 0}</Text>
                    <Text level={6} color='Text3'>
                      {company === "ICPL" ? "หน่วย" : "ตัน"}
                    </Text>
                  </FlexCol>
                );
              },
            },
            {
              title: "ยอดแต้ม",
              dataIndex: "sumPoint",
              key: "sumPoint",
              sorter: true,
              render: (value: number) => {
                return (
                  <FlexCol>
                    <Text>{value ? numberFormatter(value, 2) : 0}</Text>
                    <Text level={6} color='Text3'>
                      แต้ม
                    </Text>
                  </FlexCol>
                );
              },
            },
          ]}
          onChange={handleTableChange}
        />
      </div>
    );

    const tabBody = {
      PROGRAM: pointProgram,
      SHOP: store,
      PRODUCT: products,
    };

    useEffectOnce(() => {
      fetchTrackingData();
    });

    const fetchTrackingData = async () => {
      setLoading(true);
      await trackingCampaign(id)
        .then((res) => {
          setTrackingData(res);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    useEffect(() => {
      fetchDetail();
    }, [acttiveTab, sortField, sortOrder, filterStore, page]);

    const fetchDetail = async () => {
      setLoadingDetail(true);
      await trackingCampaignDetail({
        campaignId: id,
        followCampaignType: acttiveTab,
        ...filterStore,
        minQuantity: minMaxQtyStore[0],
        maxQuantity: minMaxQtyStore[1],
        sortBy: sortField,
        sortDirection: sortOrder,
        page,
        take: pageSize,
      })
        .then((res) => {
          setDetailData(res);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoadingDetail(false);
        });
    };

    useEffect(() => {
      if (!zoneData) {
        fetchZone();
      }
    }, [acttiveTab]);

    const fetchZone = async () => {
      await zoneDatasource
        .getAllZoneByCompany(company)
        .then((res) => {
          const data = res.map((item: any) => {
            return {
              label: item.zoneName,
              value: item.zoneName,
              key: item.zoneId,
            };
          });
          setZoneData(data);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const getParner = async (id: string, type: string) => {
      if (type === "DEALER") {
        await getPartnerDealer(id).then((res) => {
          setDataParner({ data: res, type: "DL" });
        });
      } else {
        await getPartnerSubdealer(id).then((res) => {
          setDataParner({ data: res, type: "SD" });
        });
      }
    };

    const onDownloadExcel = async () => {
      setLoadingExcel(true);
      const params = {
        campaignId: id,
      };
      try {
        const config = await excelCrmTracking(params);
        if (config) {
          const blob = new Blob([config], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          startUploadProcess(
            "",
            progressValue,
            setProgressValue,
            {
              placement: "bottomRight",
              duration: 2,
              label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
              progressInterval: 900,
            },
            async () => {
              try {
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = `รายงานภาพรวมแคมเปญพอยท์_${campaignData?.campaignCode}_${campaignData?.campaignName}_${dayjs(
                  campaignData?.startDate,
                ).format("DD/MM/YYYY")}_${dayjs(campaignData?.endDate).format("DD/MM/YYYY")}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(a.href);
                formatFileSize(blob.size);
              } catch (error) {
                message.error("Export โปรโมชันไม่สำเร็จ");
              } finally {
                setLoadingExcel(false);
              }
            },
          );
        }
      } catch (error) {
        console.error("Error submitting report:", error);
      } finally {
        setLoadingExcel(false);
      }
    };

    const DownloadOrder = () => {
      const [program, setProgram] = useState();
      const [zoneData, setZoneData] = useState<any>({});
      const [loading, setLoading] = useState(false);
      const [checkedList, setCheckedList] = useState<string[]>([]);
      const [progressValue, setProgressValue] = useState(0);
      const { startUploadProcess } = useNotificationContext();

      const fetchZone = async (campaignProgramId) => {
        setLoading(true);
        await getZoneForProgram(campaignProgramId)
          .then((res) => {
            const newData = { ...zoneData };
            newData[campaignProgramId] = res.map((z) => z?.zone);
            setZoneData(newData);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            setLoading(false);
          });
      };

      const onDownload = async () => {
        setLoadingExcel(true);
        const params = {
          campaignId: id,
          campaignProgramId: program,
          company,
          zone: checkedList,
        };
        try {
          const config = await excelCrmTracking(params);
          if (config) {
            const blob = new Blob([config], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            startUploadProcess(
              "",
              progressValue,
              setProgressValue,
              {
                placement: "bottomRight",
                duration: 2,
                label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
                progressInterval: 900,
              },
              async () => {
                try {
                  const a = document.createElement("a");
                  a.href = URL.createObjectURL(blob);
                  a.download = `รายงานแคมเปญพอยท์รายคำสั่งซื้อ_${campaignData?.campaignCode}_${campaignData?.campaignName}_${dayjs(
                    campaignData?.startDate,
                  ).format(
                    "DD/MM/YYYY",
                  )}_${dayjs(campaignData?.endDate).format("DD/MM/YYYY")}.xlsx`;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(a.href);
                  formatFileSize(blob.size);
                } catch (error) {
                  message.error("Export โปรโมชันไม่สำเร็จ");
                } finally {
                  setLoadingExcel(false);
                  setDownloadOrder(false);
                }
              },
            );
          }
        } catch (error) {
          console.error("Error submitting report:", error);
        } finally {
          setLoadingExcel(false);
          setDownloadOrder(false);
        }
      };

      return (
        <>
          <Text>เลือกพอยท์โปรแกรม และเขตการขาย</Text>
          <br />
          <br />
          <Text level={6}>พอยท์โปรแกรม</Text>
          <AntSelectCustom
            style={{ width: "100%" }}
            placeholder='เลือกพอยท์โปรแกรม'
            size='large'
            onChange={(value: any) => {
              if (!zoneData[value]) {
                fetchZone(value);
              }
              setProgram(value);
            }}
          >
            {(campaignData?.campaignPrograms || []).map(
              ({ campaignProgramName, campaignProgramId, campaignProgramType }) => {
                return (
                  <AntdSelect.Option key={campaignProgramId} value={campaignProgramId}>
                    <FlexCol>
                      <Text fontFamily='Sarabun' fontWeight={600}>
                        {campaignProgramName}
                      </Text>
                      {/* <Text level={6} color='Text3' fontFamily='Sarabun'>
                        {GET_POINT_MAPPING[campaignProgramType]}
                      </Text> */}
                    </FlexCol>
                  </AntdSelect.Option>
                );
              },
            )}
          </AntSelectCustom>
          <br />
          <br />
          {program && (
            <>
              <Text fontFamily='Sarabun' level={6} color='Text3'>
                <ExclamationCircleOutlined style={{ color: color.warning }} />
                &nbsp;จำนวนเขตที่เลือก มีผลต่อระยะเวลาเตรียมไฟล์เพื่อดาวน์โหลด
              </Text>
              <br />
              <FlexRow
                justify='space-between'
                style={{
                  marginTop: 8,
                  padding: "4px 8px",
                  backgroundColor: color.background2,
                  borderRadius: 4,
                }}
              >
                <Checkbox
                  indeterminate={
                    zoneData[program]?.length !== checkedList.length && checkedList.length > 0
                  }
                  onChange={(e) => {
                    setCheckedList(e.target.checked ? zoneData[program] : []);
                  }}
                  checked={zoneData[program]?.length === checkedList.length}
                >
                  <Text>เขตการขาย</Text>
                </Checkbox>
                <Text color='Text3'>
                  {checkedList.length > 0
                    ? `เลือกแล้ว ${checkedList.length} เขต`
                    : "ไม่มีเขตที่เลือก"}
                </Text>
              </FlexRow>
              <ScrollContainer scrollableY width={360} height={200} style={{ padding: "8px 8px" }}>
                {loading ? (
                  <PageSpin />
                ) : (
                  <CheckboxGroupContainer>
                    <Checkbox.Group
                      options={zoneData[program] || []}
                      value={checkedList}
                      onChange={(list) => setCheckedList(list)}
                      style={{ flexDirection: "column" }}
                    />
                  </CheckboxGroupContainer>
                )}
              </ScrollContainer>
            </>
          )}
          <br />
          <Button
            title='Export'
            onClick={() => {
              setDownloadOrder(false);
              onDownload();
            }}
            disabled={!program || checkedList.length <= 0}
            typeButton={!program || checkedList.length <= 0 ? "disabled" : "primary"}
          />
        </>
      );
    };

    return (
      <>
        <div style={{ padding: 16 }}>
          <Row justify='space-between'>
            <Col span={21}>
              <Text fontWeight={700}>ภาพรวมแคมเปญ</Text>
            </Col>
            <Col span={3}>
              <Dropdown
                menu={{
                  items: [
                    {
                      label: <span style={{ fontSize: 16 }}>แบบภาพรวมแคมเปญ</span>,
                      key: "1",
                      onClick: onDownloadExcel,
                    },
                    {
                      label: <span style={{ fontSize: 16 }}>แบบรายคำสั่งซื้อ</span>,
                      key: "2",
                      onClick: () => setDownloadOrder(true),
                    },
                  ],
                }}
              >
                <Button
                  title={
                    <>
                      Export &nbsp;
                      <DownOutlined style={{ fontSize: 10, marginBottom: 4 }} />
                    </>
                  }
                  icon={<img src={icon.downloadFileIcon} style={{ width: 20, height: 18 }} />}
                  typeButton='primary-light'
                  // onClick={onDownloadExcel}
                  loading={loadingExcel}
                />
              </Dropdown>
              <Modal
                centered
                title={<Text level={2}>ดาวน์โหลดรายงานแคมเปญพอยท์แบบรายคำสั่งซื้อ</Text>}
                open={showDownloadOrder}
                footer={null}
                width={420}
                onCancel={() => setDownloadOrder(false)}
              >
                <DownloadOrder />
              </Modal>
            </Col>
          </Row>
          <Container>
            {details.map((p, i) => (
              <Desc {...p} key={i} />
            ))}
          </Container>
        </div>
        <Row gutter={16}>
          <Col span={8}>
            <TrackingItem
              title='คำสั่งซื้อทั้งหมด (ยอดขน)'
              number={trackingData?.countOrder}
              unit='รายการ'
            />
          </Col>
          <Col span={8}>
            <TrackingItem
              title='ปริมาณสินค้าที่สั่งซื้อทั้งหมด'
              number={numberFormatter(trackingData?.sumQuantity, 2)}
              unit={company === "ICPL" ? "หน่วย" : "ตัน"}
              info={trackingData?.quantityUnitList}
            />
          </Col>
          <Col span={8}>
            <TrackingItem
              title={
                <>
                  <StarOutlined style={{ fontSize: 16, color: "#F0C300" }} />
                  &nbsp;ยอดแต้มทั้งหมด
                </>
              }
              number={numberFormatter(trackingData?.sumPoint, 2)}
              unit='แต้ม'
            />
          </Col>
        </Row>
        <Divider />
        <div style={{ padding: 16 }}>
          <Row justify='space-between'>
            <Text fontWeight={700}>รายละเอียดแคมเปญ</Text>
          </Row>
        </div>
        <div>
          {tabsDetail.map(({ title, icon, iconActive, key }) => {
            const isActive = acttiveTab === key;
            return (
              <AntdButton
                title={title}
                icon={<img src={isActive ? iconActive : icon} style={{ width: 16, height: 16 }} />}
                key={key}
                type={isActive ? "primary" : "default"}
                onClick={() => {
                  setActiveTab(key);
                  resetPage();
                }}
                style={{
                  marginRight: 12,
                  borderColor: color.secondary,
                  color: isActive ? "white" : color.secondary,
                  background: isActive ? color.secondary : "white",
                }}
              >
                &nbsp;{title}
              </AntdButton>
            );
          })}
        </div>
        <div>{tabBody[acttiveTab]}</div>
        <Modal
          width={800}
          open={modalParner}
          closable={true}
          onCancel={() => setModalParner(!modalParner)}
          title={
            <>
              <Text fontWeight={600} fontSize={20}>
                คู่ค้ากับ {dataParner?.type === "DL" ? "Dealer" : "Sub-Dealer"}
              </Text>
              <br />
              <Text fontWeight={400} fontSize={16} color='Text3'>
                ทั้งหมด {dataParner?.data?.length} ร้านค้า
              </Text>
            </>
          }
          centered
          footer={false}
        >
          <Table
            pagination={false}
            dataSource={dataParner?.data?.map((p, key) => ({ ...p, key })) || []}
            columns={[
              {
                title: "#",
                dataIndex: "index",
                key: "index",
                render: (value: any, row: any, index: number) => {
                  return {
                    children: <Text>{index + 1}</Text>,
                  };
                },
              },
              {
                title: "รหัสร้านค้า",
                dataIndex: "customer_no",
                key: "customer_no",
                render: (value: any, row: any, index: number) => {
                  return {
                    children: <Text>{value || "-"}</Text>,
                  };
                },
              },
              {
                title: "ชื่อร้านค้า",
                dataIndex: "customer_name",
                key: "customer_name",
                render: (value: any, row: any, index: number) => {
                  return {
                    children: <Text>{value || "-"}</Text>,
                  };
                },
              },
              {
                title: "เขต",
                dataIndex: "zone",
                key: "zone",
                render: (value: any, row: any, index: number) => {
                  return {
                    children: <Text>{value || "-"}</Text>,
                  };
                },
              },
              {
                title: "จังหวัด",
                dataIndex: "province",
                key: "province",
                render: (value: any, row: any, index: number) => {
                  return {
                    children: <Text>{value || "-"}</Text>,
                  };
                },
              },
            ]}
          />
        </Modal>
      </>
    );
  };

  const TabHistory = () => {
    const columns = [
      {
        title: "วันเวลาอัปเดท",
        dataIndex: "updateDate",
        key: "updateDate",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{dayjs(value).format("DD/MM/YYYY HH:mm น.")}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "กิจกรรม",
        dataIndex: "activityName",
        key: "activityName",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ก่อนแก้ไข",
        dataIndex: "statusBefore",
        key: "statusBefore",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Tag style={{ backgroundColor: campaignStatusColorList[value], border: "none" }}>
                  <Text color={campaignStatusTextColorList[value]} level={6} fontWeight={600}>
                    {campaignStatusNameList[value] || "-"}
                  </Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "หลังแก้ไข",
        dataIndex: "statusAfter",
        key: "statusAfter",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Tag style={{ backgroundColor: campaignStatusColorList[value], border: "none" }}>
                  <Text color={campaignStatusTextColorList[value]} level={6} fontWeight={600}>
                    {campaignStatusNameList[value] || "-"}
                  </Text>
                </Tag>
              </FlexCol>
            ),
          };
        },
      },
      {
        title: "ผู้ใช้งาน",
        dataIndex: "updateBy",
        key: "updateBy",
        render: (value: any, row: any, index: number) => {
          return {
            children: (
              <FlexCol>
                <Text>{value}</Text>
              </FlexCol>
            ),
          };
        },
      },
    ];

    return (
      <>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                headerColor: "white",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                //rowHoverBg: "none",
              },
            },
          }}
        >
          <Table
            columns={columns}
            dataSource={historyData}
            pagination={false}
            scroll={{ x: "max-content", y: 550 }}
          />
        </ConfigProvider>
      </>
    );
  };

  const tabsItems = [
    {
      key: "1",
      label: "รายละเอียด",
      children: <TabDetail />,
    },
    {
      key: "2",
      label: "ติดตามแคมเปญ",
      children: <TabTrackingDup campaignId={id} campaignData={campaignData} company />,
    },
    {
      key: "3",
      label: "ประวัติทำรายการ",
      children: <TabHistory />,
    },
  ];

  const ProgramPanelHeader = ({ i, program }: { i: number; program: CampaignProgram }) => {
    return (
      <Row style={{ padding: "24px 32px" }}>
        <Col span={12}>
          <Text color='Text3' level={6}>
            ชื่อพอยท์โปรแกรม
          </Text>
          <br />
          <Text color='Text1' level={5} fontWeight={700}>
            {program.campaignProgramName}
          </Text>
        </Col>
        <Col span={6}>
          <Text color='Text3' level={6}>
            รูปแบบการให้แต้ม
          </Text>
          <br />
          <Text color='Text1' level={5} fontWeight={700}>
            {campaignProgramTypeLabel[program.campaignProgramType]}
          </Text>
        </Col>
        <Col span={6}>
          <Text color='Text3' level={6}>
            เงื่อนไขการได้รับแต้ม
          </Text>
          <br />
          <Text color='Text1' level={5} fontWeight={700}>
            {campaignProgramConditionLabel[program.campaignProgramCondition]}
          </Text>
        </Col>
      </Row>
    );
  };

  const ProgramPanelBody = ({ i, program }: { i: number; program: CampaignProgram }) => {
    const [activeTabId, setActiveTabId] = useState<string>(tabId.store);

    const StoreTab = () => {
      const [searchStoreForm] = Form.useForm();

      const [filteredStore, setFilteredStore] = useState<StoreEntity[]>(program?.stores || []);

      const onSearchStore = (values) => {
        if (program?.stores) {
          setFilteredStore(
            program?.stores
              .filter((s) => {
                if (values.search) {
                  return s?.customerName?.indexOf(values.search) > -1;
                }
                return true;
              })
              .filter((s) => {
                if (values.zone) {
                  return s?.zone === values.zone;
                }
                return true;
              }),
          );
        } else {
          setFilteredStore([]);
        }
      };

      const columns = [
        {
          title: "รหัสร้านค้า",
          dataIndex: "dealerCode",
          key: "dealerCode",
          render: (value: any, row: any, index: number) => {
            return {
              children: <Text>{value}</Text>,
            };
          },
        },
        {
          title: "ชื่อร้านค้า",
          dataIndex: "dealerName",
          key: "dealerName",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <>
                  <Text>{value}</Text>
                  <br />
                  <Text level={6} color='Text3'>
                    {row?.customer?.taxNo}
                  </Text>
                </>
              ),
            };
          },
        },
        {
          title: "ประเภทคู่ค้า",
          dataIndex: "dealerType",
          key: "dealerType",
          render: (value: any, row: any, index: number) => {
            return {
              children: <Text level={6}>{dealerTypeName[value]}</Text>,
            };
          },
        },
        {
          title: "เขตการขาย",
          dataIndex: "dealerZone",
          key: "dealerZone",
          render: (value: any, row: any, index: number) => {
            return {
              children: <Text>{value}</Text>,
            };
          },
        },
      ];
      return (
        <>
          <Form form={searchStoreForm} onValuesChange={onSearchStore}>
            <Row gutter={16}>
              <Col span={6}>
                <Input
                  placeholder='รหัส / ชื่อร้านค้า'
                  suffix={<SearchOutlined />}
                  style={{ width: "100%", height: "40px" }}
                />
              </Col>
              <Col span={5}>
                <Select
                  placeholder='เขตทั้งหมด'
                  data={zone}
                  style={{ width: "100%", height: "40px" }}
                />
              </Col>
              <Col span={10} />
            </Row>
          </Form>
          <br />
          <TableContainer>
            <Table
              columns={columns}
              dataSource={filteredStore || program.stores}
              scroll={{ y: 600 }}
              pagination={false}
            />
          </TableContainer>
        </>
      );
    };

    const ProductTab = () => {
      const [searchProductForm] = Form.useForm();
      const [filteredProd, setFilteredProd] = useState<ProductEntity[]>(program?.products || []);
      const onSearchProduct = (values) => {
        if (program?.products) {
          setFilteredProd(
            program?.products.filter((s) => {
              if (values.search) {
                return s?.productName?.indexOf(values.search) > -1;
              }
              return true;
            }),
          );
        } else {
          setFilteredProd([]);
        }
      };

      const columns = [
        {
          title: "ชื่อสินค้า",
          dataIndex: "name",
          key: "productName",
          width: "40%",
          render: (value: any, row: any, index: number) => {
            return {
              children: (
                <Row gutter={8} style={{ padding: "12px 0px" }}>
                  <Col>
                    <Avatar
                      src={row.productImage ? row.productImage : image.product_no_image}
                      size={70}
                      shape='square'
                      onError={() => false}
                    />
                  </Col>
                  <Col>
                    <Text>{row.productName}</Text>
                    <br />
                    {row.commonName && row.commonName.length > 0 && (
                      <>
                        <Text level={6}>
                          {row.commonName.length > 35
                            ? row.commonName.slice(0, 35) + "..."
                            : row.commonName}
                        </Text>
                        <br />
                      </>
                    )}
                    <Text level={6} color='Text3'>
                      Product Group : {row.productGroup || "-"}
                    </Text>
                    {company === "ICPL" && (
                      <>
                        <br />
                        <Text level={6} color='Text3'>
                          Stragery Group : {row.productStrategy || "-"}
                        </Text>
                      </>
                    )}
                  </Col>
                </Row>
              ),
            };
          },
        },
        {
          dataIndex: "packSize",
          render: (value: any, row: any) => {
            return (
              <FlexCol>
                <Text>{value}</Text>
                <Text color='Text3'>{row.productCodeNAV}</Text>
              </FlexCol>
            );
          },
        },
        {
          title: "แต้มที่ได้รับ",
          dataIndex: "productId",
          key: "point",
          width: "42%",
          render: (productId: any, row: any) => {
            return (
              <Row gutter={16} align='middle'>
                <Col span={15}>
                  <Text level={5}>
                    <img src={icon.star} style={{ width: "16px" }} />
                    &nbsp;แต้มที่ได้รับ
                  </Text>
                  <Input
                    suffix={<Text level={5}>แต้ม</Text>}
                    disabled
                    value={row.programPoints}
                    size='large'
                    style={{ width: "100%", color: color.BK }}
                  />
                </Col>
                <Col span={9}>
                  <Text level={5}>ต่อหน่วย SKU</Text>
                  <Input
                    disabled
                    value={row.saleUOMTH}
                    size='large'
                    style={{ width: "100%", color: color.BK }}
                  />
                </Col>
              </Row>
            );
          },
        },
      ];

      return (
        <>
          <Form form={searchProductForm} onValuesChange={onSearchProduct}>
            <Row gutter={16}>
              <Col span={6}>
                <Input
                  placeholder='รหัส / ชื่อสินค้า'
                  suffix={<SearchOutlined />}
                  style={{ width: "100%", height: "40px" }}
                />
              </Col>
              <Col span={18} />
            </Row>
          </Form>
          <br />
          <TableContainer>
            <Table
              columns={columns}
              dataSource={filteredProd}
              scroll={{ y: 600 }}
              pagination={false}
            />
          </TableContainer>
        </>
      );
    };

    return (
      <ProgramTabsContainer style={{ background: color.background4 }}>
        <Row gutter={4}>
          <TabHeader
            itemId={tabId.store}
            title='ร้านค้า'
            count={program.stores?.length || 0}
            isActive={activeTabId === tabId.store}
            setActive={setActiveTabId}
          />
          <TabHeader
            itemId={tabId.product}
            title='สินค้า'
            count={program.products?.length || 0}
            isActive={activeTabId === tabId.product}
            setActive={setActiveTabId}
          />
        </Row>
        <TabBody>{activeTabId === tabId.store ? <StoreTab /> : <ProductTab />}</TabBody>
      </ProgramTabsContainer>
    );
  };

  return (
    <>
      <CardContainer>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            <PageTitle />
            <br />
            <Tabs data={tabsItems} />
          </>
        )}
      </CardContainer>
    </>
  );
};

const TabTrackingDup = ({
  campaignId,
  campaignData,
  company,
}: {
  campaignId: string;
  campaignData: any;
  company: any;
}) => {
  const { companyType } = JSON.parse(localStorage.getItem("company")!);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [showDownloadOrder, setDownloadOrder] = useState(false);
  const { startUploadProcess } = useNotificationContext();
  const [trackingData, setTrackingData] = useState<any>();
  const [page, setPage] = useState("1");
  const [pageSize, setPageSize] = useState("10");
  const [detailData, setDetailData] = useState<any>();
  const [activeTab, setActiveTab] = useState("PROGRAM");

  const fetchTrackingData = async () => {
    await trackingCampaign(campaignId)
      .then((res) => {
        //console.log("info", res);
        setTrackingData(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const fetchDetail = async () => {
    await trackingCampaignDetail({
      campaignId: campaignId,
      followCampaignType: activeTab,
      page: Number(page),
      take: Number(pageSize),
    })
      .then((res) => {
        console.log("detail", res);
        setDetailData(res);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchTrackingData();
    fetchDetail();
  }, [campaignId, activeTab, page, pageSize]);

  const DashboardInfo = () => {
    const info =
      companyType === "Fertilizer"
        ? [
            {
              label: "ปริมาณรวม (ตัน)",
              value: numberFormatter(trackingData?.sumQuantity || 0, 2),
              key: "1",
              icon: icon.box_point_icon,
              hidden: false,
            },
            {
              label: "แต้มรอบริษัทอนุมัติ",
              value: numberFormatter(trackingData?.sumPointWaitApprove || 0, 2),
              key: "2",
              icon: icon.clock_point_icon,
              hidden: false,
            },
            {
              label: "แต้มที่ใช้ได้ (บริษัทอนุมัติแล้ว)",
              value: numberFormatter(trackingData?.sumPoint || 0, 2),
              key: "3",
              icon: icon.green_star_point_icon,
              hidden: false,
            },
            {
              label: "แต้มหมดอายุ",
              value: numberFormatter(trackingData?.sumPointUsed || 0, 2),
              key: "3",
              icon: icon.gray_star_point_icon,
              hidden: false,
            },
          ]
        : [
            {
              label: "รอกดรับสินค้า",
              value: numberFormatter(trackingData?.sumPointWaitApprove || 0, 2),
              key: "2",
              icon: icon.clock_point_icon,
              hidden: false,
            },
            {
              label: "แต้มที่ใช้ได้ (ยืนยันรับสินค้าแล้ว)",
              value: numberFormatter(trackingData?.sumPoint || 0, 2),
              key: "3",
              icon: icon.green_star_point_icon,
              hidden: false,
            },
          ];

    return (
      <Row justify='space-between' gutter={16}>
        {info.map((item, index) => {
          if (item.hidden) return null;
          return (
            <Col
              span={
                companyType === "Fertilizer" && index < 3
                  ? 8
                  : companyType === "Fertilizer" && index > 2
                    ? 24
                    : 12
              }
              key={item.key}
              style={{ marginBottom: "12px" }}
            >
              <Card bodyStyle={{ padding: "16px" }}>
                <Row justify='space-between' style={{ alignItems: "middle" }}>
                  <FlexCol>
                    <Text level={6}>
                      <img
                        src={item.icon}
                        alt={item.label}
                        style={{ width: "20px", height: "20px" }}
                      />
                      &nbsp;
                      {item.label}
                    </Text>
                    <Text level={2} fontWeight={700}>
                      {item.value}
                    </Text>
                  </FlexCol>
                </Row>
              </Card>
            </Col>
          );
        })}
      </Row>
    );
  };

  const details = [
    {
      label: "รหัสแคมเปญ",
      value: trackingData?.campaignCode,
    },
    {
      label: "ชื่อแคมเปญ",
      value: trackingData?.campaignName,
    },
    {
      label: "รูปแบบการให้แต้ม",
      value:
        campaignData?.campaignProgramType === "ONLY_SUB_DEALER"
          ? "ให้ Sub-Dealer เท่านั้น"
          : "ให้ Dealer เท่านั้น",
    },
    {
      label: "วันหมดอายุแต้ม",
      value: dayjs(campaignData?.pointExpireDateใ).format("DD/MM/BBBB"),
    },
    {
      label: "ระยะเวลาแคมเปญ",
      icon: <img src={icon.crmCalendar} style={{ width: 16, height: 16 }} />,
      value:
        `${
          trackingData?.startDate ? dayjs(trackingData?.startDate).format("DD/MM/YYYY") : ""
        } - ${trackingData?.endDate ? dayjs(trackingData?.endDate).format("DD/MM/YYYY") : ""}` +
        (trackingData?.daysPassed && trackingData?.daysPassed > 0
          ? ` (ผ่านมาแล้ว ${trackingData?.daysPassed} วัน)`
          : ""),
    },
    {
      label: "ร้านค้าที่เข้าร่วม",
      icon: <img src={icon.crmStore} style={{ width: 16, height: 16 }} />,
      value: <>{`${trackingData?.countShop || 0}/${trackingData?.countShopAll} ร้าน `}</>,
    },
  ];
  const itemTab = [
    {
      label: "พอยท์โปรแกรม",
      key: "PROGRAM",
      children: (
        <PointProgramTab
          companyType={companyType}
          data={detailData}
          pageSize={pageSize}
          page={page}
          setPage={setPage}
          setPageSize={setPageSize}
        />
      ),
      hidden: false,
    },
    {
      label: "แต้มร้านค้า",
      key: "POINT_SHOP",
      children: (
        <ShopPointTab
          isHideDashboard={true}
          data={detailData}
          pageSize={pageSize}
          page={page}
          setPage={setPage}
          setPageSize={setPageSize}
        />
      ),
      hidden: false,
    },
    {
      label: "ประวัติแต้ม",
      key: "HISTORY_POINT",
      children: (
        <HistoryPointTab
          data={detailData}
          pageSize={pageSize}
          page={page}
          setPage={setPage}
          setPageSize={setPageSize}
        />
      ),
      hidden: false,
    },
    {
      label: "คูปอง",
      key: "COUPON",
      children: <CouponTab />,
      hidden: companyType === "Chemical",
    },
    {
      label: "รายงานเบิกชดเชย Dealer",
      key: "DEALER_REPORT",
      children: <DealerReportTab />,
      hidden: companyType === "Chemical",
    },
  ];

  const onDownloadExcel = async () => {
    setLoadingExcel(true);
    const params = {
      campaignId: campaignId,
    };
    try {
      const config = await excelCrmTracking(params);
      if (config) {
        const blob = new Blob([config], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        startUploadProcess(
          "",
          progressValue,
          setProgressValue,
          {
            placement: "bottomRight",
            duration: 2,
            label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
            progressInterval: 900,
          },
          async () => {
            try {
              const a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = `รายงานภาพรวมแคมเปญพอยท์_${campaignData?.campaignCode}_${campaignData?.campaignName}_${dayjs(
                campaignData?.startDate,
              ).format("DD/MM/YYYY")}_${dayjs(campaignData?.endDate).format("DD/MM/YYYY")}.xlsx`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(a.href);
              formatFileSize(blob.size);
            } catch (error) {
              message.error("Export โปรโมชันไม่สำเร็จ");
            } finally {
              setLoadingExcel(false);
            }
          },
        );
      }
    } catch (error) {
      console.error("Error submitting report:", error);
    } finally {
      setLoadingExcel(false);
    }
  };

  const DownloadOrder = () => {
    const [program, setProgram] = useState();
    const [zoneData, setZoneData] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [checkedList, setCheckedList] = useState<string[]>([]);
    const [progressValue, setProgressValue] = useState(0);
    const { startUploadProcess } = useNotificationContext();

    const fetchZone = async (campaignProgramId) => {
      setLoading(true);
      await getZoneForProgram(campaignProgramId)
        .then((res) => {
          const newData = { ...zoneData };
          newData[campaignProgramId] = res.map((z) => z?.zone);
          setZoneData(newData);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    const onDownload = async () => {
      setLoadingExcel(true);
      const params = {
        campaignId: campaignId,
        campaignProgramId: program,
        company,
        zone: checkedList,
      };
      try {
        const config = await excelCrmTracking(params);
        if (config) {
          const blob = new Blob([config], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          startUploadProcess(
            "",
            progressValue,
            setProgressValue,
            {
              placement: "bottomRight",
              duration: 2,
              label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
              progressInterval: 900,
            },
            async () => {
              try {
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = `รายงานแคมเปญพอยท์รายคำสั่งซื้อ_${campaignData?.campaignCode || "-"}_${campaignData?.campaignName || "-"}_${dayjs(
                  campaignData?.startDate,
                ).format("DD/MM/YYYY")}_${dayjs(campaignData?.endDate).format("DD/MM/YYYY")}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(a.href);
                formatFileSize(blob.size);
              } catch (error) {
                message.error("Export โปรโมชันไม่สำเร็จ");
              } finally {
                setLoadingExcel(false);
                setDownloadOrder(false);
              }
            },
          );
        }
      } catch (error) {
        console.error("Error submitting report:", error);
      } finally {
        setLoadingExcel(false);
        setDownloadOrder(false);
      }
    };

    return (
      <>
        <Text>เลือกพอยท์โปรแกรม และเขตการขาย</Text>
        <br />
        <br />
        <Text level={6}>พอยท์โปรแกรม</Text>
        <AntSelectCustom
          style={{ width: "100%" }}
          placeholder='เลือกพอยท์โปรแกรม'
          size='large'
          onChange={(value: any) => {
            if (!zoneData[value]) {
              fetchZone(value);
            }
            setProgram(value);
          }}
        >
          {(campaignData?.campaignPrograms || []).map(
            ({ campaignProgramName, campaignProgramId, campaignProgramType }) => {
              return (
                <AntdSelect.Option key={campaignProgramId} value={campaignProgramId}>
                  <FlexCol>
                    <Text fontFamily='Sarabun' fontWeight={600}>
                      {campaignProgramName}
                    </Text>
                    {/* <Text level={6} color='Text3' fontFamily='Sarabun'>
                        {GET_POINT_MAPPING[campaignProgramType]}
                      </Text> */}
                  </FlexCol>
                </AntdSelect.Option>
              );
            },
          )}
        </AntSelectCustom>
        <br />
        <br />
        {program && (
          <>
            <Text fontFamily='Sarabun' level={6} color='Text3'>
              <ExclamationCircleOutlined style={{ color: color.warning }} />
              &nbsp;จำนวนเขตที่เลือก มีผลต่อระยะเวลาเตรียมไฟล์เพื่อดาวน์โหลด
            </Text>
            <br />
            <FlexRow
              justify='space-between'
              style={{
                marginTop: 8,
                padding: "4px 8px",
                backgroundColor: color.background2,
                borderRadius: 4,
              }}
            >
              <Checkbox
                indeterminate={
                  zoneData[program]?.length !== checkedList.length && checkedList.length > 0
                }
                onChange={(e) => {
                  setCheckedList(e.target.checked ? zoneData[program] : []);
                }}
                checked={zoneData[program]?.length === checkedList.length}
              >
                <Text>เขตการขาย</Text>
              </Checkbox>
              <Text color='Text3'>
                {checkedList.length > 0
                  ? `เลือกแล้ว ${checkedList.length} เขต`
                  : "ไม่มีเขตที่เลือก"}
              </Text>
            </FlexRow>
            <ScrollContainer scrollableY width={360} height={200} style={{ padding: "8px 8px" }}>
              {loading ? (
                <PageSpin />
              ) : (
                <CheckboxGroupContainer>
                  <Checkbox.Group
                    options={zoneData[program] || []}
                    value={checkedList}
                    onChange={(list) => setCheckedList(list)}
                    style={{ flexDirection: "column" }}
                  />
                </CheckboxGroupContainer>
              )}
            </ScrollContainer>
          </>
        )}
        <br />
        <Button
          title='Export'
          onClick={() => {
            setDownloadOrder(false);
            onDownload();
          }}
          disabled={!program || checkedList.length <= 0}
          typeButton={!program || checkedList.length <= 0 ? "disabled" : "primary"}
        />
      </>
    );
  };

  return (
    <div style={{ padding: 16 }}>
      <Row justify='space-between'>
        <Col span={21}>
          <Text fontWeight={700}>ภาพรวมแคมเปญ</Text>
        </Col>
        <Col span={3}>
          <Dropdown
            menu={{
              items: [
                {
                  label: <span style={{ fontSize: 16 }}>แบบภาพรวมแคมเปญ</span>,
                  key: "1",
                  onClick: onDownloadExcel,
                },
                {
                  label: <span style={{ fontSize: 16 }}>แบบรายคำสั่งซื้อ</span>,
                  key: "2",
                  onClick: () => setDownloadOrder(true),
                },
              ],
            }}
          >
            <Button
              title={
                <>
                  Export &nbsp;
                  <DownOutlined style={{ fontSize: 10, marginBottom: 4 }} />
                </>
              }
              icon={<img src={icon.downloadFileIcon} style={{ width: 20, height: 18 }} />}
              typeButton='primary-light'
              // onClick={onDownloadExcel}
              loading={loadingExcel}
            />
          </Dropdown>
          <Modal
            centered
            title={<Text level={2}>ดาวน์โหลดรายงานแคมเปญพอยท์แบบรายคำสั่งซื้อ</Text>}
            open={showDownloadOrder}
            footer={null}
            width={420}
            onCancel={() => setDownloadOrder(false)}
          >
            <DownloadOrder />
          </Modal>
        </Col>
      </Row>
      <Container>
        {details.map((p, i) => (
          <Desc {...p} key={i} />
        ))}
      </Container>
      <DashboardInfo />
      <AntdTabs
        style={{ fontFamily: "IBM Plex Sans Thai" }}
        items={itemTab.filter((item) => !item.hidden)}
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
      />
    </div>
  );
};

const PointProgramTab = ({
  companyType,
  data,
  pageSize,
  page,
  setPage,
  setPageSize,
}: {
  companyType: string;
  data: any;
  pageSize?: string;
  page?: string;
  setPage?: any;
  setPageSize?: any;
}) => {
  const columns =
    companyType === "Fertilizer"
      ? [
          {
            title: "ชื่อพอยท์โปรแกรม",
            dataIndex: "campaignProgramName",
            key: "campaignProgramName",
          },
          {
            title: "เงื่อนไขได้รับแต้ม",
            dataIndex: "campaignProgramCondition",
            key: "campaignProgramCondition",
            render: (value: any) => <Text>{campaignProgramConditionLabel[value]}</Text>,
          },
          {
            title: "จำนวนร้านค้า",
            dataIndex: "countShop",
            key: "countShop",
          },
          {
            title: "ปริมาณรวม (ตัน)",
            dataIndex: "sumQuantity",
            key: "sumQuantity",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "รออนุมัติแต้ม",
            dataIndex: "sumPointWaitApprove",
            key: "sumPointWaitApprove",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มที่ใช้ได้",
            dataIndex: "sumPoint",
            key: "sumPoint",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มที่แลกแล้ว",
            dataIndex: "sumPointDecrease",
            key: "sumPointDecrease",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มหมดอายุ",
            dataIndex: "sumPointExpired",
            key: "sumPointExpired",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
        ]
      : [
          {
            title: "ชื่อพอยท์โปรแกรม",
            dataIndex: "campaignProgramName",
            key: "campaignProgramName",
          },
          {
            title: "เงื่อนไขได้รับแต้ม",
            dataIndex: "campaignProgramCondition",
            key: "campaignProgramCondition",
            render: (value: any) => <Text>{campaignProgramConditionLabel[value]}</Text>,
          },
          {
            title: "จำนวนร้านค้า",
            dataIndex: "countShop",
            key: "countShop",
          },
          {
            title: "แต้มรอกดรับสินค้า",
            dataIndex: "sumPointWaitApprove",
            key: "sumPointWaitApprove",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
          {
            title: "แต้มที่ใช้ได้",
            dataIndex: "sumPoint",
            key: "sumPoint",
            render: (value: any) => <Text>{numberFormatter(value || 0, 2)}</Text>,
          },
        ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: "#F3F6F9",
            fontFamily: "IBM Plex Sans Thai",
            fontSize: 15,
          },
        },
      }}
    >
      <Table
        columns={columns}
        dataSource={data?.data}
        scroll={{ x: "max-content" }}
        pagination={{
          pageSize: Number(pageSize) || 10,
          current: Number(page) || 1,
          total: data?.count || 0,
          showSizeChanger: false,
          position: ["bottomCenter"],
          onChange: (page, size) => {
            const nextPage = String(page);
            setPage(nextPage);
            setPageSize(String(size));
          },
        }}
      />
    </ConfigProvider>
  );
};
